import { FeatureMockFrame } from './FeatureMockFrame';
import type { FeatureMockSize } from './FeatureMockFrame';

export const WAITLIST_CLAIM_MOCK_ALT =
  'CourtSync lesson waitlist showing a spot opening, guardian notification, and claim confirmation';

interface WaitlistClaimMockProps {
  size?: FeatureMockSize;
  className?: string;
}

export function WaitlistClaimMock({ size = 'compact', className }: WaitlistClaimMockProps) {
  return (
    <FeatureMockFrame
      id="waitlists"
      alt={WAITLIST_CLAIM_MOCK_ALT}
      size={size}
      className={className}
    >
      <div className="csm-waitlist">
        <div className="csm-waitlist-lesson">
          <span className="csm-waitlist-lesson-name">Junior Orange Ball</span>
          <span className="csm-waitlist-capacity csm-waitlist-capacity--full">8/8 Full</span>
        </div>
        <div className="csm-waitlist-cancellation">
          <span className="csm-waitlist-cancel-icon">×</span>
          <span>Booking cancelled — spot available</span>
        </div>
        <div className="csm-waitlist-capacity csm-waitlist-capacity--open">7/8 · 1 spot</div>
        <div className="csm-waitlist-queue">
          <div className="csm-waitlist-row csm-waitlist-row--1">
            <div className="csm-avatar">AK</div>
            <span className="csm-waitlist-name">Amelia K.</span>
            <span className="csm-status csm-status--waiting">Waiting</span>
          </div>
          <div className="csm-waitlist-row csm-waitlist-row--2">
            <div className="csm-avatar">JL</div>
            <span className="csm-waitlist-name">James L.</span>
            <span className="csm-status csm-status--waiting">Waiting</span>
          </div>
          <div className="csm-waitlist-row csm-waitlist-row--3">
            <div className="csm-avatar">SM</div>
            <span className="csm-waitlist-name">Sophie M.</span>
            <span className="csm-status csm-status--waiting">Waiting</span>
          </div>
        </div>
        <div className="csm-waitlist-notify">
          <span className="csm-waitlist-notify-label">Notified</span>
          <span className="csm-waitlist-claim-chip">Claim spot →</span>
        </div>
        <div className="csm-waitlist-claimed">
          <div className="csm-avatar">AK</div>
          <span className="csm-waitlist-name">Amelia K.</span>
          <span className="csm-status csm-status--claimed">Claimed</span>
        </div>
        <div className="csm-waitlist-capacity csm-waitlist-capacity--restored">8/8 Full</div>
      </div>
    </FeatureMockFrame>
  );
}
